export default "__VITE_ASSET__I_AmK4vt__"